module.exports = __webpack_public_path__ + "img/LONG-SLEEVE-TEE_FRONT_RED-FRONT.7515d9a6.jpg";